import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { Box, Button, Typography } from "@mui/material";
import { inputType } from "../../types/types";


export function InterlinkedInputs(props:{entityList:string[], exisitingMappingList: inputType[], setMapping:React.Dispatch<React.SetStateAction<inputType[]>>}) {
    
    const [unusedOptionsList, setUnUsedOptions] = useState<string[]>([]);

    useEffect(() => {
        const defaultUnusedList = props.exisitingMappingList.length>0 ? props.entityList.filter((item)=> !props.exisitingMappingList.map((profile)=>profile.key).includes(item)) : [];
        const unusedOptions = defaultUnusedList.length ===0 ? props.entityList.filter((key) =>
            !props.exisitingMappingList.map((input) => input.key).includes(key)
        ) : defaultUnusedList;
        setUnUsedOptions(unusedOptions);
    },[props.entityList, props.exisitingMappingList]);

    const handleAddRow = () => {
        props.setMapping([...props.exisitingMappingList, { key: unusedOptionsList[0], value: unusedOptionsList[0] }]);
    };
    const handleInputChange = (index: number, value: string) => {
        const newList = props.exisitingMappingList.slice();
        newList[index].value = value;
        props.setMapping(newList);
    }
    const handleSelectChange = (index: number, value: string) => {
        const newList = props.exisitingMappingList.slice();
        newList[index].key = value;
        props.setMapping(newList);
    }
    const handleRemoveEntity = (index: number) =>{
        const newList = props.exisitingMappingList.filter((listObject,idx)=>index !== idx)
        props.setMapping(newList);
    }

    return (
        <Box marginY={2}>
            <Box marginY={2}
                display="flex" 
                flexDirection="row" 
                justifyContent="space-between"
                alignItems="center"
                >
                    <Typography variant="h6">Attributes</Typography>
                    {<Button className="navigation-btn" variant="contained" onClick={handleAddRow}>+</Button>}
            </Box>
            {props.exisitingMappingList.map((input, index) => input.key!=='dateFormat' &&
                <EntityInput key={index} entityList={props.entityList}  unusedOptionsList={unusedOptionsList}
                input={props.exisitingMappingList[index]} 
                handleChange={(val: string) => handleInputChange(index, val)} 
                handleSelect={(val: string) => handleSelectChange(index,val)}
                handleRemove={() => handleRemoveEntity(index)}
                />
            )}
        </Box>
    );
}

function EntityInput(props: { entityList: string[],unusedOptionsList: string[], input: inputType, handleChange: Function, handleSelect:Function, handleRemove :Function}) {
   return (
        <Box display="flex" flexDirection="row" gap={2} alignItems="center">
            <TextField
                select
                label="Select an option"
                variant="outlined"
                margin="normal"
                onChange={(e)=>props.handleSelect(e.target.value)}
                value={props.input.key}
                fullWidth
            >
                {
                    props.entityList.map(entity => <MenuItem disabled={!props.unusedOptionsList.includes(entity)} key={entity} value={entity}>{entity}</MenuItem>)
                }
            </TextField>
            <TextField
                label={`Enter the value `}
                variant="outlined"
                margin="normal"
                fullWidth
                value={props.input.value}
                onChange={(e) => props.handleChange(e.target.value)}
            />
            <Button className="navigation-btn" variant="contained" onClick={()=>props.handleRemove()}>-</Button>
        </Box>
    )
}